module.exports = __webpack_public_path__ + "static/media/richariche_pvr.2604beee.png";